import C from '../assets/images/C.png'
import L2 from '../assets/images/L2.png'
import L3 from '../assets/images/L3.png'
import L4 from '../assets/images/L4.png'
import L6 from '../assets/images/L6.png'
import Li4 from '../assets/images/Li4.png'
import Li6 from '../assets/images/Li6.png'
import Pr0 from '../assets/images/Pr0.png'
import Pr1 from '../assets/images/Pr1.png'
import Pa0 from '../assets/images/Pa0.png'
import Pa1 from '../assets/images/Pa1.png'
import Pc0 from '../assets/images/Pc0.png'
import Pc1 from '../assets/images/Pc1.png'

import ms from '../assets/images/ms.png'
import mns from '../assets/images/mns.png'
import mn from '../assets/images/mn.png'

import * as draw from '../utils/draw'

export const TOOL_TYPES = {
  STM: 'symmetry',
  AREA: 'area'
}

// 虚线不参与统计
export const SYM_TOOL_ORDER = ['L6', 'Li6', 'L4', 'Li4', 'L3', 'L2', { key: 'P', sub: [/* 'Pr0', 'Pa0', 'Pc0', */'Pr1', 'Pa1', 'Pc1'] }, 'C']

export const LABEL_MAPPING = {
  L6:   { name: 'L', sup: '6' },
  Li6:  { name: 'Li', sup: '6' },
  L4:   { name: 'L', sup: '4' },
  Li4:  { name: 'Li', sup: '4' },
  L3:   { name: 'L', sup: '3' },
  L2:   { name: 'L', sup: '2' },
  Pr0:  { name: 'Pr0', sup: null },
  Pa0:  { name: 'Pa0', sup: null },
  Pc0:  { name: 'Pc0', sup: null },
  Pr1:  { name: 'Pr1', sup: null },
  Pa1:  { name: 'Pa1', sup: null },
  Pc1:  { name: 'Pc1', sup: null },
  P:    { name: 'P', sup: null },
  C:    { name: 'C', sup: null },
}

export default [
  { key: 'mns', url: mns, areaCount: 2, type: TOOL_TYPES.AREA, initialWidth: 20, initialHeight: 20 },
  { key: 'ms', url: ms, areaCount: 1, type: TOOL_TYPES.AREA, initialWidth: 16, initialHeight: 16 },
  { key: 'mn', url: mn, areaCount: 1, type: TOOL_TYPES.AREA, initialWidth: 16, initialHeight: 16 },
  
  { key: 'C', url: C, type: TOOL_TYPES.STM, previewSize: '50% 50%', initialWidth: 15, initialHeight: 16 },
  { key: 'L2', url: L2, type: TOOL_TYPES.STM, initialWidth: 40, initialHeight: 40 },
  { key: 'L3', url: L3, type: TOOL_TYPES.STM, initialWidth: 40, initialHeight: 40 },
  { key: 'L4', url: L4, type: TOOL_TYPES.STM },
  { key: 'L6', url: L6, type: TOOL_TYPES.STM, initialWidth: 34, initialHeight: 34 },
  { key: 'Li4', url: Li4, type: TOOL_TYPES.STM, initialWidth: 36, initialHeight: 36 },
  { key: 'Li6', url: Li6, type: TOOL_TYPES.STM, initialWidth: 36, initialHeight: 36 },
  {
    key: 'Pr1',
    url: Pr1,
    type: TOOL_TYPES.STM,
    render: ctx => diameterRenderer(ctx.options.width - ctx.options.padding * 2, 2),
    offsetRotation: 90,
    initialX: ctx => ctx.options.padding,
    initialY: ctx => ctx.options.padding + (ctx.options.height - ctx.options.padding * 2) / 2 - 4 / 2,
    initialWidth: ctx => ctx.options.width - ctx.options.padding * 2,
    initialHeight: 4,
    initialRotation: 45,
    allowTranslate: false,
    selectByContent: true,
  },
  {
    key: 'Pa1',
    url: Pa1,
    type: TOOL_TYPES.STM,
    render: ctx => bigArcRenderer((ctx.options.width - ctx.options.padding * 2) / 2, (ctx.options.width - ctx.options.padding * 2) / 2, (ctx.options.width - ctx.options.padding * 2) / 2),
    initialX: ctx => ctx.options.padding,
    initialY: ctx => ctx.options.padding,
    initialWidth: ctx => ctx.options.width - ctx.options.padding * 2,
    initialHeight: ctx => ctx.options.width - ctx.options.padding * 2,
    initialRotation: 0,
    allowTranslate: false,
    selectByContent: true,
  },
  {
    key: 'Pc1',
    url: Pc1,
    type: TOOL_TYPES.STM,
    render: ctx => bigCircleRenderer((ctx.options.width - ctx.options.padding * 2) / 2, (ctx.options.width - ctx.options.padding * 2) / 2, (ctx.options.width - ctx.options.padding * 2) / 2, false),
    initialX: ctx => ctx.options.padding,
    initialY: ctx => ctx.options.padding,
    initialWidth: ctx => ctx.options.width - ctx.options.padding * 2,
    initialHeight: ctx => ctx.options.width - ctx.options.padding * 2,
    initialRotation: 0,
    allowTranslate: false,
    selectByContent: true,
  },
  {
    key: 'Pr0',
    url: Pr0,
    type: TOOL_TYPES.STM,
    render: ctx => diameterRenderer(ctx.options.width - ctx.options.padding * 2, 2, true),
    offsetRotation: 90,
    initialX: ctx => ctx.options.padding,
    initialY: ctx => ctx.options.padding + (ctx.options.height - ctx.options.padding * 2) / 2 - 4 / 2,
    initialWidth: ctx => ctx.options.width - ctx.options.padding * 2,
    initialHeight: 4,
    initialRotation: 45,
    allowTranslate: false,
    selectByContent: true,
  },
  {
    key: 'Pa0',
    url: Pa0,
    type: TOOL_TYPES.STM,
    render: ctx => bigArcRenderer((ctx.options.width - ctx.options.padding * 2) / 2, (ctx.options.width - ctx.options.padding * 2) / 2, (ctx.options.width - ctx.options.padding * 2) / 2, true),
    initialX: ctx => ctx.options.padding,
    initialY: ctx => ctx.options.padding,
    initialWidth: ctx => ctx.options.width - ctx.options.padding * 2,
    initialHeight: ctx => ctx.options.width - ctx.options.padding * 2,
    initialRotation: 0,
    allowTranslate: false,
    selectByContent: true,
  },
  {
    key: 'Pc0',
    url: Pc0,
    type: TOOL_TYPES.STM,
    render: ctx => bigCircleRenderer((ctx.options.width - ctx.options.padding * 2) / 2, (ctx.options.width - ctx.options.padding * 2) / 2, (ctx.options.width - ctx.options.padding * 2) / 2, true),
    initialX: ctx => ctx.options.padding,
    initialY: ctx => ctx.options.padding,
    initialWidth: ctx => ctx.options.width - ctx.options.padding * 2,
    initialHeight: ctx => ctx.options.width - ctx.options.padding * 2,
    initialRotation: 0,
    allowTranslate: false,
    selectByContent: true,
  }
]

const diameterRenderer = (length, width, dashed) => {
  const canvas = document.createElement('canvas')
  const w = canvas.width = length
  const h = canvas.height = width
  const context = canvas.getContext('2d')
  draw.drawLine(context)({
    x1: 0,
    y1: (h - width) / 2,
    x2: w,
    y2: (h - width) / 2,
    lineWidth: width,
    color: 'black',
    dashed
  })
  return canvas.toDataURL()
}

const bigArcRenderer = (x, y, r, dashed) => {
  const canvas = document.createElement('canvas')
  canvas.width = 2 * r
  canvas.height = 2 * r
  const context = canvas.getContext('2d')
  draw.draw45Arc(context)({ x, y, r, color: 'black', dashed })
  return canvas.toDataURL()
}

const bigCircleRenderer = (x, y, r, dashed) => {
  const canvas = document.createElement('canvas')
  canvas.width = 2 * r
  canvas.height = 2 * r
  const context = canvas.getContext('2d')
  draw.drawCircle(context)({ x, y, r: r - 2, dashed }) // use r - 2 to avoid border clip
  return canvas.toDataURL()
}


// WEBPACK FOOTER //
// ./src/constants/tools.js